import { useDateTimeLocalizationInfo, TimeService } from '@mews/framework';

export const useDefaultTriggerTime = () => {
    const localizationInfo = useDateTimeLocalizationInfo();
    return TimeService.toShortString(TimeService.parse('08:00:00'), localizationInfo);
};
